import { useEffect } from 'react'

/**
 * Sets the browser tab title for the page that mounts it.
 *
 * NO CLEANUP, and that is the whole point (N-0-audit finding N-2, 07.08.2026).
 * This hook used to capture the previous title on mount and RESTORE it on
 * unmount. Measured on production: the restore ran after the incoming page had
 * already set its own title, so every in-app navigation left the tab showing
 * the PREVIOUS page — click «Tilbud» and the tab read «Kalender», click
 * «Varsler» and it read «Tilbud». Bookmarks and history entries inherited the
 * wrong name, and screen readers announced the wrong page on navigation.
 *
 * The next page owns the title. A title hook has nothing to restore, because
 * there is no state to hand back: whatever mounts next sets it, and if nothing
 * mounts the tab is closing anyway. All 40 call sites are pages (no modals), so
 * every unmount here is a route change.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | EventRipple` : 'EventRipple'
  }, [title])
}
